import React, { useState, lazy } from 'react';
import { motion } from 'framer-motion';
import { ZapIcon } from 'lucide-react';
export function PriceBox() {
  const [selectedPlan, setSelectedPlan] = useState<'basico' | 'completo'>('completo');
  const plans = {
    basico: {
      label: 'OFERTA PRINCIPAL',
      name: 'Recetario Ancestral',
      subtitle: '🌿 Todo para comenzar tu transformación natural',
      features: ['Libro Principal Recetario Ancestral', '5 Bonus Exclusivos'],
      footerText: 'Ideal para comenzar desde cero.',
      price: '19.990',
      oldPrice: '39.990',
      checkoutUrl: 'https://digiital-factory.shop/cart/49943309549845:1',
      image: 'https://cdn.magicpatterns.com/uploads/bcZi5Zv4ZrVNKCryvTHxZM/1_2B_5.webp'
    },
    completo: {
      label: 'ACCESO COMPLETO',
      name: 'Recetario Ancestral Premium',
      subtitle: '✨ Llevate todo el contenido disponible por una pequeña diferencia',
      features: ['Libro Principal', '5 Bonus Iniciales', '5 Bonus Extra', 'Guía Maestra', 'Índice General del Recetario'],
      footerText: 'Más contenido. Más recetas. Más herramientas.',
      price: '25.990',
      oldPrice: '55.990',
      checkoutUrl: 'https://digiital-factory.shop/cart/49943311974677:1',
      image: 'https://cdn.magicpatterns.com/uploads/pQC2VJjoj22q8XQ6zj17vR/12B10_todo.webp'
    }
  };
  return <section id="pricing" className="py-24 bg-[#f5f0e1] relative overflow-hidden pt-[10px] pb-[30px] space-y-[6px]" data-id="element-150">
      <div className="max-w-6xl mx-auto px-4 bg-transparent pl-[16px] pr-[16px] space-y-[6px]" data-id="element-151">
        <div className="text-center mb-12" data-id="element-152">
          <h2 className="text-3xl md:text-5xl font-black text-[#2f4a2c] tracking-tight leading-tight" data-id="element-153">
            Elegí tu acceso al{' '}
            <span className="text-[#2f8f3a]" data-id="element-154">Recetario Ancestral</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6 max-w-3xl mx-auto" data-id="element-155">
          {/* Tarjeta 1: Oferta Principal */}
          <button onClick={() => setSelectedPlan('basico')} className={`relative p-4 rounded-2xl border-2 transition-all text-left flex flex-col h-full group ${selectedPlan === 'basico' ? 'border-[#2f8f3a] bg-white shadow-[0_10px_30px_rgba(47,143,58,0.1)] scale-[1.01]' : 'border-[#cfdcc2] bg-white/50 hover:border-[#2f8f3a]/40'}`} data-id="element-156">
            <span className="inline-block px-2.5 py-1 rounded-full bg-[#f4f8ef] font-black tracking-widest uppercase mb-3 text-[12px] text-[#ED0ECF]" data-id="element-157">
              {plans.basico.label}
            </span>
            <h3 className="text-[#2f4a2c] mb-1 text-[22px] font-[800]" data-id="element-158">
              {plans.basico.name}
            </h3>
            <p className="text-[#2f8f3a] font-bold mb-3 text-[13px]" data-id="element-159">
              {plans.basico.subtitle}
            </p>
            <ul className="space-y-1.5 mb-4 flex-grow" data-id="element-160">
              {plans.basico.features.map((f, i) => <li key={i} className="flex items-start gap-2 font-medium text-[17px] text-[#111210]" data-id="element-161">
                  <span className="text-[#2f8f3a]" data-id="element-162">•</span>
                  {f}
                </li>)}
            </ul>
            <div className="mt-auto" data-id="element-163">
              <div className="flex items-baseline gap-2 mb-3" data-id="element-164">
                <p className="line-through font-bold text-[13px] text-[#F02D0B] bg-[#F5EEEE]" data-id="element-165">
                  ${plans.basico.oldPrice}
                </p>
                <p className="text-2xl font-black text-[#4FC05C]" data-id="element-166">
                  ${plans.basico.price}
                </p>
              </div>
              <div className={`w-full h-[36px] rounded-[8px] font-bold text-center text-xs transition-all flex items-center justify-center ${selectedPlan === 'basico' ? 'bg-[#2f8f3a] text-white shadow-md' : 'bg-[#f4f8ef] text-[#2f8f3a] border border-[#2f8f3a]/20'}`} data-id="element-167">
                {selectedPlan === 'basico' ? 'SELECCIONADO' : 'SELECCIONAR'}
              </div>
            </div>
          </button>

          {/* Tarjeta 2: Oferta Recomendada */}
          <button onClick={() => setSelectedPlan('completo')} className={`relative p-4 rounded-2xl border-2 transition-all text-left flex flex-col h-full group ${selectedPlan === 'completo' ? 'border-[#2f8f3a] bg-white shadow-[0_10px_30px_rgba(47,143,58,0.1)] scale-[1.01]' : 'border-[#cfdcc2] bg-white/50 hover:border-[#2f8f3a]/40'}`} data-id="element-168">
            <div className="absolute -top-3 right-4 px-2.5 py-1 rounded-full uppercase tracking-widest shadow-md z-10 text-[10px] font-[800] text-[#1B1919] bg-[#FFEE00] pt-[0px] pb-[0px] pl-[8px] pr-[8px] mt-[0px] mb-[0px] ml-[0px] mr-[0px]" data-id="element-169">
              ★ Más elegido
            </div>
            <span className="inline-block px-2.5 py-1 rounded-full bg-[#f4f8ef] font-black tracking-widest uppercase mb-3 text-[12px] text-[#E204E9]" data-id="element-170">
              {plans.completo.label}
            </span>
            <h3 className="font-black text-[#2f4a2c] mb-1 text-[22px]" data-id="element-171">
              {plans.completo.name}
            </h3>
            <p className="text-[#2f8f3a] font-bold mb-3 text-[13px]" data-id="element-172">
              {plans.completo.subtitle}
            </p>
            <ul className="space-y-1.5 mb-4 flex-grow" data-id="element-173">
              {plans.completo.features.map((f, i) => <li key={i} className="flex items-start gap-2 font-medium text-[17px] text-[#0F0F0E]" data-id="element-174">
                  <span className="text-[#2f8f3a]" data-id="element-175">•</span>
                  {f}
                </li>)}
            </ul>
            <div className="mt-auto" data-id="element-176">
              <div className="flex items-baseline gap-2 mb-3" data-id="element-177">
                <p className="line-through font-bold text-[13px] text-[#F72E0A]" data-id="element-178">
                  ${plans.completo.oldPrice}
                </p>
                <p className="text-2xl font-black text-[#43B050]" data-id="element-179">
                  ${plans.completo.price}
                </p>
              </div>
              <div className={`${`w-full h-[36px] rounded-[8px] font-bold text-center text-xs transition-all flex items-center justify-center ${selectedPlan === 'completo' ? 'bg-[#2f8f3a] text-white shadow-md' : 'bg-[#f4f8ef] text-[#2f8f3a] border border-[#2f8f3a]/20'}`} bg-[#01D81A]`} data-id="element-180">
                {selectedPlan === 'completo' ? 'SELECCIONADO' : 'SELECCIONAR'}
              </div>
            </div>
          </button>
        </div>

        {/* Mockup Image Container */}
        <div className="relative mb-16 w-full" data-id="element-181">
          <motion.div key={selectedPlan} initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} className="relative z-0 w-full" data-id="element-182">
            <img src={plans[selectedPlan].image} alt="Mockup Recetario Ancestral" className="w-full h-auto block" data-id="element-183" />
          </motion.div>
        </div>

        {/* Final CTA Container */}
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-184">
          <a href={plans[selectedPlan].checkoutUrl} rel="noopener noreferrer" className="w-full inline-flex items-center justify-center text-white font-black py-8 rounded-[2rem] shadow-[0_20px_50px_rgba(47,143,58,0.3)] hover:shadow-[0_25px_60px_rgba(47,143,58,0.4)] transition-all hover:scale-[1.02] md:text-3xl uppercase tracking-wider mb-8 bg-[#1B9D24] text-[20px]" data-id="element-185">
            Si, QUIERO ACCEDER AHORA!
          </a>

          <div className="flex flex-wrap justify-center items-center gap-6 text-[#5d6b54] text-xs font-black uppercase tracking-widest" data-id="element-186">
            <div className="flex items-center gap-2" data-id="element-187">
              <span className="text-[#2f8f3a]" data-id="element-188">🔒</span> Pago Seguro
            </div>
            <div className="flex items-center gap-2" data-id="element-189">
              <span className="text-[#2f8f3a]" data-id="element-190">📥</span> Acceso Inmediato
            </div>
            <div className="flex items-center gap-2" data-id="element-191">
              <span className="text-[#2f8f3a]" data-id="element-192">✅</span> Garantía de 7 Días
            </div>
          </div>
        </div>

        {/* Payment Security Section */}
        <div className="bg-white rounded-2xl mt-8 mb-[18px] overflow-hidden" data-id="element-193">
          {/* MercadoLíder Platinum */}
          <div className="p-4 border-t border-gray-200" data-id="element-194">
            <div className="flex items-center justify-center gap-2 mb-3" data-id="element-195">
              <svg className="w-5 h-5 text-[#1E4620]" fill="currentColor" viewBox="0 0 20 20" data-id="element-196">
                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-197" />
              </svg>
              <h6 className="text-sm font-extrabold text-[#1E4620] uppercase" data-id="element-198">
                MercadoLíder Platinum
              </h6>
            </div>
            <p className="text-xs text-center text-[#388E3C] font-bold mb-4" data-id="element-199">
              ¡Es uno de los mejores del sitio!
            </p>

            {/* Progress Bar */}
            <div className="h-2 bg-gradient-to-r from-red-500 via-yellow-400 to-green-500 rounded-full mb-4" data-id="element-200"></div>

            {/* Stats Grid */}
            <div className="grid grid-cols-3 gap-4 text-center" data-id="element-201">
              <div data-id="element-202">
                <p className="text-2xl font-extrabold text-gray-800 font-['DM_Sans',_sans-serif]" data-id="element-203">
                  2436
                </p>
                <p className="text-[10px] text-gray-600 leading-tight" data-id="element-204">
                  Ventas en los
                  <br data-id="element-205" />
                  últimos 60 días
                </p>
              </div>
              <div data-id="element-206">
                <div className="flex justify-center mb-1" data-id="element-207">
                  <div className="relative" data-id="element-208">
                    <svg className="w-8 h-8 text-gray-300" fill="currentColor" viewBox="0 0 20 20" data-id="element-209">
                      <path fillRule="evenodd" d="M18 10c0 3.866-3.582 7-8 7a8.841 8.841 0 01-4.083-.98L2 17l1.338-3.123C2.493 12.767 2 11.434 2 10c0-3.866 3.582-7 8-7s8 3.134 8 7zM7 9H5v2h2V9zm8 0h-2v2h2V9zM9 9h2v2H9V9z" clipRule="evenodd" data-id="element-210" />
                    </svg>
                    <svg className="absolute -bottom-1 -right-1 w-4 h-4 text-[#388E3C] bg-white rounded-full" fill="currentColor" viewBox="0 0 20 20" data-id="element-211">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" data-id="element-212" />
                    </svg>
                  </div>
                </div>
                <p className="text-[10px] text-gray-600 leading-tight" data-id="element-213">
                  Brinda buena
                  <br data-id="element-214" />
                  atención
                </p>
              </div>
              <div data-id="element-215">
                <div className="flex justify-center mb-1" data-id="element-216">
                  <div className="relative" data-id="element-217">
                    <svg className="w-8 h-8 text-gray-300" fill="currentColor" viewBox="0 0 20 20" data-id="element-218">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.414L11 9.586V6z" clipRule="evenodd" data-id="element-219" />
                    </svg>
                    <svg className="absolute -bottom-1 -right-1 w-4 h-4 text-[#388E3C] bg-white rounded-full" fill="currentColor" viewBox="0 0 20 20" data-id="element-220">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" data-id="element-221" />
                    </svg>
                  </div>
                </div>
                <p className="text-[10px] text-gray-600 leading-tight" data-id="element-222">
                  Despacha sus
                  <br data-id="element-223" />
                  productos a tiempo
                </p>
              </div>
            </div>
          </div>

          {/* Trust Badges Row */}
          <div className="flex flex-row justify-center items-center gap-6 mt-4 pt-4 border-t border-gray-200" data-id="element-224">
            {/* 7 Days Guarantee */}
            <div className="flex flex-col items-center" data-id="element-225">
              <img src="https://cdn.magicpatterns.com/uploads/33L4RSMNtqLmpgL3G8P8RF/7_dias.jpg" alt="7 Días Garantía" width={96} height={96} loading="lazy" decoding="async" className="w-24 h-24 object-contain" data-id="element-226" />
            </div>

            {/* Secure Purchase */}
            <div className="flex items-center gap-3" data-id="element-227">
              <div className="relative w-16 h-16" data-id="element-228">
                <svg className="w-full h-full text-[#388E3C]" fill="currentColor" viewBox="0 0 20 20" data-id="element-229">
                  <path fillRule="evenodd" d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-230" />
                </svg>
                <svg className="absolute bottom-0 right-0 w-6 h-6 text-[#388E3C] bg-white rounded-full" fill="currentColor" viewBox="0 0 20 20" data-id="element-231">
                  <path d="M3 1a1 1 0 000 2h1.22l.305 1.222a.997.997 0 00.01.042l1.358 5.43-.893.892C3.74 11.846 4.632 14 6.414 14H15a1 1 0 000-2H6.414l1-1H14a1 1 0 00.894-.553l3-6A1 1 0 0017 3H6.28l-.31-1.243A1 1 0 005 1H3zM16 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM6.5 18a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" data-id="element-232" />
                </svg>
              </div>
              <div data-id="element-233">
                <p className="text-lg font-extrabold text-[#388E3C] uppercase leading-tight" data-id="element-234">
                  Compra Segura
                </p>
                <p className="text-xs font-bold text-[#388E3C]" data-id="element-235">
                  Compra 100% Segura
                </p>
              </div>
            </div>
          </div>
          {/* Small Lifetime Guarantee Integration */}
          <div className="px-4 pb-4 text-center" data-id="element-236">
            <p className="text-[11px] font-bold text-[#388E3C] flex items-center justify-center gap-1 uppercase tracking-tight" data-id="element-237">
              <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20" data-id="element-238">
                <path fillRule="evenodd" d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-239" />
              </svg>
              Garantía de por vida: te devolvemos el dinero si no estás conforme
            </p>
          </div>
        </div>

        {/* Support Section */}
        <div className="mt-6 text-center" data-id="element-240">
          <p className="text-gray-600 text-sm mb-2" data-id="element-241">
            ¿Problemas con tu compra?
          </p>
          <a href="mailto:soportesinfinstudio@gmail.com" className="inline-flex items-center gap-2 text-blue-600 hover:text-blue-500 font-bold transition-colors group" data-id="element-242">
            <span data-id="element-243">Chateá con nosotros: soportedigitalfactory@gmail.com</span>
            <svg className="w-4 h-4 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-244">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3" data-id="element-245"></path>
            </svg>
          </a>
        </div>
      </div>
    </section>;
}